// Simple localStorage-backed favorites store for verses.
// Each favorite is the full verse object plus an `addedAt` ISO timestamp.

const KEY = "lifted_daily.favorites.v1";

const safeParse = (raw) => {
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const getFavorites = () => {
  if (typeof window === "undefined") return [];
  return safeParse(window.localStorage.getItem(KEY));
};

export const isFavorite = (verse, list) => {
  if (!verse) return false;
  const items = list || getFavorites();
  return items.some(
    (f) => f.reference === verse.reference && f.translation === verse.translation
  );
};

export const addFavorite = (verse) => {
  const items = getFavorites();
  if (isFavorite(verse, items)) return items;
  const next = [{ ...verse, addedAt: new Date().toISOString() }, ...items];
  window.localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const removeFavorite = (verse) => {
  const items = getFavorites();
  const next = items.filter(
    (f) => !(f.reference === verse.reference && f.translation === verse.translation)
  );
  window.localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const toggleFavorite = (verse) => {
  return isFavorite(verse) ? removeFavorite(verse) : addFavorite(verse);
};
